<template>
  <div class="BrandsPage">
      <div class="container">
        <StorySlider :stories="response.stories"/>
        <ImageSlider :images="response.sliders" v-if="755 < screen" />
        <ImageSliderMobile :images="response.sliders" v-if="755 >= screen" />
          <div class="club-input my-4" dir="rtl">
            <input type="text" class="form-control without-border-radius" v-model="q" placeholder="نام برند ...">
            <button aria-label="جستجو" @click="searchBrand(q)" type="button" class="btn btn-secondary club-btn right-input-btn">جستجو</button>
          </div>
        <div v-for="(category, index) in categories" :key="(category, index)">
            <h2 class="text-end">{{category.name}}</h2>
            <div dir="rtl" v-if="category.brands.length == 0 && (collections.filter(c => c.categories.includes(parseInt(category.id))).length == 0)">
              <p class="text-center">موردی یافت نشد.</p>
            </div>
            <div class="overflow-auto">
                <div class="d-flex">
                    <div class="margin-brand text-center shadow-hover" :key="obj" v-for="obj in category.brands">
                        <router-link class="twkc" :to="'/brand/'+obj.slug">
                            <img class="brand-img bg-brand mb-3" v-lazy="$MEDIA + obj.image" :alt="obj.name">
                            <p>{{strLimit(obj.name,20)}}</p>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="mt-3 mb-5" v-if="(collections.filter(c => c.categories.includes(parseInt(category.id))).length !=0)">
              <CollectionCarousel :collections="collections.filter(c => c.categories.includes(parseInt(category.id)))" />
            </div>
            <hr />
        </div>
        <PageContent mode="BrandsPage" />
      </div>
  </div>
</template>
<script>
import ImageSlider from '@/components/ImageSlider.vue'
import ImageSliderMobile from '@/components/ImageSliderMobile.vue'
import PageContent from '@/components/PageContent.vue'
import CollectionCarousel from '@/components/CollectionCarousel.vue'
import StorySlider from '@/components/StorySlider.vue'

export default {
  name: 'BrandsPage',
  components: {
    ImageSlider,
    ImageSliderMobile,
    PageContent,
    CollectionCarousel,
    StorySlider
  },
  data () {
    return {
      categories: this.$categories,
      response: {},
      collections: [],
      screen: screen.width,
      q: ''
    }
  },
  methods: {
    searchBrand: function (q) {
      this.categories = structuredClone(this.$categories)
      this.collections = this.response.collections
      if (q !== '') {
        let brands = []
        let collections = []
        for (const category in this.categories) {
          brands = this.categories[category].brands.filter(brand => brand.name.toLowerCase().includes(q))
          this.categories[category].brands = brands
          collections = this.collections.filter(collection => collection.name.toLowerCase().includes(q))
          this.collections = collections
        }
      }
    }
  },
  mounted () {
    const query = `
{
  collections(filters: {}) {
    id
    categories
    slug
    name
    description
    image
  }
  meta(key:"${this.$options.name}") {
    seoTitle
    seoKeyword
    seoDescription
  }
  sliders (key: "BrandsPage") {
    imageMobile
    image
    alt
    link
  }
  stories (key: "BrandsPage") {
    id
    videoCover
    link
    video
    prev
    next
  }
}
    `
    this.$fetchGraphQL(query)
      .then(response => {
        this.response = response.data
        this.setMetaByObj(response.data.meta)
        this.collections = response.data.collections
      })
  }
}
</script>

<style scoped>
.twkc{
  text-align: -webkit-center;
}
.brand-img{
  width:180px;
  border-radius: 24px 20px 0px 0px;
}
.drop-shadow{
  filter: drop-shadow(0px 2px 5px rgba(50, 50, 0, 0.2));
}
img{
  width: -webkit-fill-available;
  border-radius: 24px;
}
.title-c{
  color: white;
  background: #808080b3;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 12px;
}
.brand-name{
    border: solid #e8acd4 2px;
    color: black;
    padding: 10px;
    border-radius: 24px;
    width: max-content;
}
.margin-brand{margin: 15px 6px;}
.bg-brand{
  background-image: url('../../assets/brand.jpg')!important;
  background-size: cover;
  padding: 20%;
}
.shadow-hover{
  border: solid 1px #d1d1d1;
  border-radius: 16px;
  transition: 0.4s;
}
.shadow-hover:hover{
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px white;
}
</style>
